import { postData_ } from 'helpers/Helper'
import { APP_PATH, GET_DASHBOARD_, GET_TOTAL_ADMIN_API_, GET_API_VALIDITY_ADMIN, GET_API_VALIDITY_ADMIN_SECOND, GET_API_LOG } from './apiPath'
import { getDashboard, getDashboardApiCallsAdmin, getAdminValidityApiAdmin, getAdminValidityApiAdminSecond, getAdminLogData } from 'store/actions/dashboard';
import { persist_store } from 'store/actions/index';

export function getDashboard_(value, callback) {
  return (dispatch) => {
    dispatch(persist_store({ loader: true }));
    return postData_(`${GET_DASHBOARD_}`, value)
      .then((data) => {
        dispatch(getDashboard(data, callback));
        dispatch(persist_store({ loader: false }));
        return data;
      })
      .catch(error => {
        dispatch(persist_store({ loader: false }));
        console.error('Error fetching data:', error);
      });
  };
}

export function getDashboardApiCalls_(value, callback) {
  return (dispatch) => {
    dispatch(persist_store({ loader: true }));
    return postData_(`${GET_TOTAL_ADMIN_API_}`, value)
      .then((data) => {
        dispatch(getDashboardApiCallsAdmin(data, callback));
        dispatch(persist_store({ loader: false }));
        return data;
      })
      .catch(error => {
        dispatch(persist_store({ loader: false }));
        console.error('Error fetching data:', error);
      });
  };
}

export function getAdminValidityApi_(value, callback) {
  return (dispatch) => {
    dispatch(persist_store({ loader: true }));
    return postData_(`${GET_API_VALIDITY_ADMIN}`, value)
      .then((data) => {
        dispatch(getAdminValidityApiAdmin(data, callback));
        dispatch(persist_store({ loader: false }));
        return data;
      })
      .catch(error => {
        dispatch(persist_store({ loader: false }));
        console.error('Error fetching data:', error);
      });
  };
}

export function getAdminValidityApiSecond_(value, callback) {
  return (dispatch) => {
    dispatch(persist_store({ loader: true }));
    return postData_(`${GET_API_VALIDITY_ADMIN_SECOND}`, value)
      .then((data) => {
        dispatch(getAdminValidityApiAdminSecond(data, callback));
        dispatch(persist_store({ loader: false }));
        return data;
      })
      .catch(error => {
        dispatch(persist_store({ loader: false }));
        console.error('Error fetching data:', error);
      });
  };
}

export function getAdminLogData_(value, callback) {
  return (dispatch) => {
    dispatch(persist_store({ loader: true }));
    return postData_(`${GET_API_LOG}`, value)
      .then((data) => {
        dispatch(getAdminLogData(data, callback));
        dispatch(persist_store({ loader: false }));
        return data;
      })
      .catch(error => {
        dispatch(persist_store({ loader: false }));
        console.error('Error fetching data:', error);
      });
  };
}
